import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20still%20life%20composition%20with%20sneakers%20leather%20bag%20sunglasses%20and%20a%20silk%20scarf%20arranged%20organically%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20golden%20morning%20sunlight%20streaming%20diagonally%20from%20upper%20right%20corner%2C%20gentle%20shadows%20with%20diffused%20edges%2C%20editorial%20magazine%20cover%20aesthetic%2C%20warm%20earthy%20color%20palette%20with%20touches%20of%20olive%20and%20rust%2C%20airy%20mediterranean%20atmosphere&width=1800&height=1200&seq=hero-bg-main-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/20 to-cream-50/70"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-24 pb-12">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-warm-950">
              Itaobuy{' '}
              <span className="text-tealwarm-600">Spreadsheet</span>{' '}
              <span className="block">Italiano 2026</span>
            </h1>
            <p className="mt-5 text-sm md:text-base text-warm-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              Trova prodotti verificati, QC foto e migliori offerte in un unico posto. Scopri il miglior{' '}
              <strong>itaobuy spreadsheet</strong> aggiornato per sneakers, streetwear, accessori e prodotti selezionati con informazioni dettagliate e guide complete.
            </p>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-warm-600 text-white text-sm md:text-base font-semibold hover:bg-warm-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Accedi all&apos;Itaobuy Spreadsheet aggiornato
                <i className="ri-arrow-right-line"></i>
              </a>
              <Link
                to="/itaobuy-spreadsheet-guida-completa"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-warm-300 text-warm-800 text-sm md:text-base font-semibold hover:bg-warm-50 transition-all whitespace-nowrap cursor-pointer"
              >
                Scopri come funziona
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <span className="inline-flex items-center gap-1.5 text-xs text-warm-500">
                <i className="ri-checkbox-circle-fill text-tealwarm-600 text-sm"></i> Liste aggiornate
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-warm-500">
                <i className="ri-checkbox-circle-fill text-tealwarm-600 text-sm"></i> Prodotti organizzati
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-warm-500">
                <i className="ri-checkbox-circle-fill text-tealwarm-600 text-sm"></i> Guide in italiano
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-warm-500">
                <i className="ri-checkbox-circle-fill text-tealwarm-600 text-sm"></i> Metodo semplice
              </span>
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20tablet%20floating%20in%20midair%20displaying%20a%20clean%20organized%20product%20catalog%20grid%20with%20fashion%20items%20each%20in%20their%20own%20cell%20with%20tiny%20thumbnail%20images%2C%20soft%20glowing%20screen%20light%2C%20dark%20mode%20interface%20with%20warm%20accent%20colors%2C%20floating%20above%20a%20light%20oak%20desk%20surface%2C%20futuristic%20minimal%20tech%20aesthetic%2C%203D%20render%20style%20with%20soft%20ambient%20lighting&width=800&height=800&seq=hero-spreadsheet-mock-v2&orientation=squarish"
                alt="Itaobuy Spreadsheet preview"
                className="w-full rounded-2xl"
              />
            </div>
          </div>
        </div>

        <div className="mt-16 lg:mt-20 max-w-4xl mx-auto">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 md:p-8">
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-center">
              {[
                { icon: 'ri-time-line', label: 'Risparmia Tempo', desc: 'Prodotti già organizzati' },
                { icon: 'ri-star-line', label: 'Migliore Selezione', desc: 'Evita ricerche casuali' },
                { icon: 'ri-zoom-in-line', label: 'QC Foto', desc: 'Analizza ogni dettaglio' },
                { icon: 'ri-global-line', label: 'Guida Italiana', desc: 'Per nuovi utenti' },
                { icon: 'ri-shield-check-line', label: 'Sicurezza', desc: 'Link verificati' },
              ].map((item) => (
                <div key={item.label} className="flex flex-col items-center gap-2 p-3">
                  <div className="w-11 h-11 rounded-full bg-tealwarm-50 flex items-center justify-center text-tealwarm-600">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <p className="text-sm font-semibold text-warm-900 whitespace-nowrap">{item.label}</p>
                  <p className="text-xs text-warm-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}